import { register } from '@/features/auth/services/authService'
import { useTranslation } from 'react-i18next'

import { z } from 'zod'

export const useRegisterFormConfig = () => {
  const { t } = useTranslation()

  const formConfig = {
    id: 'register-form',
    fields: [
      {
        name: 'email',
        label: 'test@test.com',
        type: 'label'
      },
      {
        name: 'password',
        label: t('AUTHORIZATION.REGISTER.PASSWORD.LABEL'),
        placeholder: t('AUTHORIZATION.REGISTER.PASSWORD.PLACEHOLDER'),
        type: 'password',
        required: true
      },
      {
        name: 'confirm_password',
        label: t('AUTHORIZATION.REGISTER.CONFIRM_PASSWORD.LABEL'),
        placeholder: t('AUTHORIZATION.REGISTER.CONFIRM_PASSWORD.PLACEHOLDER'),
        type: 'password',
        required: true
      }
    ],
    validationSchema: z
      .object({
        password: z
          .string({
            required_error: t(
              'AUTHORIZATION.REGISTER.PASSWORD.VALIDATION.REQUIRED'
            )
          })
          .trim()
          .min(8, {
            message: t('AUTHORIZATION.REGISTER.PASSWORD.VALIDATION.TOO_SHORT')
          })
          .regex(/^(?=.*[A-Z])(?=.*[!@#$%^&*])(?=.*\d).+$/, {
            message: t('AUTHORIZATION.REGISTER.PASSWORD.VALIDATION.INVALID')
          }),
        confirm_password: z
          .string({
            required_error: t(
              'AUTHORIZATION.REGISTER.CONFIRM_PASSWORD.VALIDATION.REQUIRED'
            )
          })
          .trim()
          .min(8, {
            message: t(
              'AUTHORIZATION.REGISTER.CONFIRM_PASSWORD.VALIDATION.TOO_SHORT'
            )
          })
      })
      .refine(data => data.password === data.confirm_password, {
        message: t(
          'AUTHORIZATION.REGISTER.CONFIRM_PASSWORD.VALIDATION.NOT_MATCH'
        ),
        path: ['confirm_password']
      }),
    onSubmit: (data: Record<string, any>) => {
      register('test2@test.com', data.password)
    }
  }
  return formConfig
}
